// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Capture_capture__1Y08Z {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: .5rem;\n}\n.Capture_capture__1Y08Z button{\n\tpadding: .5rem;\n}", "",{"version":3,"sources":["webpack://src/Capture.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,8BAA8B;CAC9B,oBAAoB;AACrB;AACA;CACC,cAAc;AACf","sourcesContent":[".capture {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: .5rem;\n}\n.capture button{\n\tpadding: .5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"capture": "Capture_capture__1Y08Z"
};
export default ___CSS_LOADER_EXPORT___;
